/**
 * Set up routing for all UserEvaluation views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import userEvaluation views
import CreateUserEvaluation from './views/CreateUserEvaluation.js.jsx';
import UserEvaluationList from './views/UserEvaluationList.js.jsx';
import SingleUserEvaluation from './views/SingleUserEvaluation.js.jsx';
import UpdateUserEvaluation from './views/UpdateUserEvaluation.js.jsx';

class UserEvaluationRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <Route exact path="/user-evaluations" component={UserEvaluationList} />
        <YTRoute login={true} exact path="/user-evaluations/new" component={CreateUserEvaluation} />
        <Route exact path="/user-evaluations/:userEvaluationId" component={SingleUserEvaluation}/>
        <YTRoute login={true} exact path="/user-evaluations/:userEvaluationId/update" component={UpdateUserEvaluation}/>
      </Switch>
    )
  }
}

export default UserEvaluationRouter;



// WEBPACK FOOTER //
// modules/userEvaluation/UserEvaluationRouter.js.jsx